<template>
  <div>
    <app-header />
    <mpn-page-title :title="pageTitle" />
    <main class="a-service-main">
      <div class="tab_wrap tab_wrap_renew">
        <div class="box_title_area total">
          <h3 class="service-title-b">
            전체 <em>{{ totalNumOfPacks }}</em
            >개
          </h3>
        </div>
        <ul class="tab_menu">
          <li
            data-id="con1"
            :class="{ on: currentTab == 'single' }"
            @click="changeTab('single')"
          >
            1회 구매
          </li>
          <li
            data-id="con2"
            :class="{ on: currentTab == 'recurring' }"
            @click="changeTab('recurring')"
          >
            정기 구매
          </li>
        </ul>
        <div id="con1" class="conBox" :class="{ on: currentTab == 'single' }">
          <mypacks-tab-contents
            purchase-type="single"
            :pack-list="singlePackList"
            :pack-count="singlePackCount"
            @update-pack-count="updatePackCount"
          />
        </div>
        <div
          id="con2"
          class="conBox"
          :class="{ on: currentTab == 'recurring' }"
        >
          <mypacks-tab-contents
            purchase-type="recurring"
            :pack-list="recurringPackList"
            :pack-count="recurringPackCount"
            @update-pack-count="updatePackCount"
          />
        </div>
      </div>
    </main>
    <app-footer />
    <modal-alert ref="refAlert" />
  </div>
</template>

<script>
import packApi from "@/apis/pack";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import MypacksTabContents from "./partial/MypacksTabContents.vue";
import ModalAlert from "@/components/global/ModalAlert.vue";

export default {
  name: "Mypacks",
  components: {
    AppHeader,
    MypacksTabContents,
    AppFooter,
    ModalAlert,
  },
  data() {
    return {
      pageTitle: "마이팩 목록",
      currentTab: "single",
      singlePackList: [],
      singlePackCount: 0,
      recurringPackList: [],
      recurringPackCount: 0,
      totalNumOfPacks: 0,

      req_no: null,
    };
  },
  mounted() {
    const initialTab = this.$route.query.tab;
    if (initialTab) {
      console.log("initialTab", initialTab);
      this.currentTab = initialTab;
    }
    this.$store.dispatch("resetOrderInfo");
  },
  created() {
    this.fetchPackList();
  },
  methods: {
    async fetchPackList() {
      let r = await packApi.getPagedOrderInfo("", "1", "", "single");
      this.singlePackList = r.packList
      this.singlePackCount = r.totalCount;

      r = await packApi.getPagedOrderInfo("", "1", "", "recurring");
      this.recurringPackList = r.packList
      this.recurringPackCount = r.totalCount;

      this.totalNumOfPacks = this.singlePackCount + this.recurringPackCount;
    },
    updatePackCount() {
      this.totalNumOfPacks -= 1;
    },
    changeTab(tab) {
      if(this.currentTab == tab) {
        return;
      }

      this.currentTab = tab;

      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          tab: tab,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/mypacks/main/Mypacks.vue